export default "__VITE_ASSET__BcnHWGmb__"